import { useDispatch, useSelector } from "react-redux";
import classes from "./TestResult.module.css"
import { RootState } from "../../Store/store";
import { useEffect, useMemo, useState } from "react";
import { ILesson } from "../../Intarfaces/ILesson";
import Button1 from "../../Components/UI/Button1/Button1";
import Button2 from "../../Components/UI/Button2/Button2";
import { lastStep } from "../../Store/userSlice";
import { useNavigate } from "react-router-dom";
import { ITest } from "../../Intarfaces/ITest";

const TestResult = () => {

    const dispatch = useDispatch()
    const lessons = useSelector((state:RootState)=>state.user.lessons)
    const maxActiveLessonId = useSelector((state:RootState)=>state.user.maxActiveLessonId)
    const test = useSelector((state:RootState)=>state.user.test)
    const [lessonActive, setLessonActive]  = useState<ILesson>(lessons[maxActiveLessonId])
    const nav = useNavigate()

    const [answers, setAnswers] = useState<{[index:number]:number|null}>({
        ...Object.assign({}, [...test.map((it,i )=>null)])
    })
 
    const setValue=(id:number, value:number)=>{
        setAnswers((state)=>{return {  ...state,[id]:value}})
    }


    return ( 
        <div className={classes.education}>
            <div className={classes.container}> 

                {
                   maxActiveLessonId===lessons.length 
                   ?
                   <div className={classes.lessonContainer}>
                        <div className={classes.titleTrue}>
                           <p>Тестирование успешно пройдено!</p> 
                            <p>Скачать сертификат можно в личном кабинете</p>
                        </div>
                        
                            <Button1 onClick={()=>nav('/accaunt')}>Перейти в личный кабинет</Button1>
                                           
                    </div>
                    :
                    <div className={classes.lessonContainer}>
                    <div className={classes.title}>
                        Тестирование не пройдено
                    </div>
                    <div className={classes.buttons}>
                        <Button2 onClick={()=>nav('/education')}>Вернутся к занятиям</Button2>
                        <Button1 onClick={()=>nav('/test')}>Начать тестирование заново</Button1>
                    </div>                    
                </div>
                }
                
                
            </div>
            
        </div>
     );
}
 
export default TestResult;